class KlaviyoModal extends HTMLElement {
  constructor() {
    super();

    this.klaviyoModal = document.querySelector('.klaviyo-popup-modal')
    this.klaviyoForm = document.querySelector('.klaviyo-bis-form')
    this.emailInput = document.querySelector('#klaviyo-bis-email')
    this.klaviyoOpt = document.querySelector('[for="bis_marketing"]')
    this.errorMessage = document.querySelector('.klaviyo-bis-form .form__message')
    this.triggerButton = null

    document.addEventListener(
      'keyup',
      (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
    )

    this.klaviyoForm.addEventListener('submit', this.handleSubmit.bind(this))

    document.addEventListener('click', event => {
      if (!event.target.closest('.klaviyo-bis-trigger')) return;

      event.preventDefault();
      this.open(event)
    })

    document.addEventListener('click', event => {
      if (!event.target.closest('.klaviyo-popup-modal__close')) return;

      this.close()
    })

    this.klaviyoModal.addEventListener('click', event => {
      if (event.target.closest('.klaviyo-popup-modal__content')) return;

      this.close()
    })

    this.klaviyoOpt.addEventListener('keyup', event => {
      if (event.keyCode !== 31 && event.code !== 'Space') return

      const prevSibling = event.target.previousElementSibling
      if (prevSibling.id === 'bis_marketing' && prevSibling.type === 'checkbox' ) {
        prevSibling.checked = !prevSibling.checked
      }
    })
  }

  isOpen () {
    return this.klaviyoModal.hasAttribute('open')
  }

  open (event) {
    const { product, variant } = event.target.dataset
    this.triggerButton = event.target

    this.initProductHtml(product, variant)

    trapFocus(this, this.querySelector('[role="dialog"]'))

    document.querySelector('[bis-product-holder]').classList.add('hidden')
    document.querySelector('.klaviyo-bis__success').outerHTML = document.querySelector('.klaviyo-bis__success').outerHTML.replace(/div/g, 'template')
    document.querySelector('.klaviyo-bis-form').classList.remove('hidden')
    document.body.classList.add('overflow-none')
    this.klaviyoModal.setAttribute('open', true)

    this.emailInput.focus()
  }

  close () {
    if (this.isOpen) {
      document.body.classList.remove('overflow-none')
      this.klaviyoModal.removeAttribute('open', true)
      this.triggerButton && this.triggerButton.focus()

      removeTrapFocus(this.openedBy)
    }
  }

  getImageWithSize (src = '', size = 1000) {
    return ('' + src).replace(/([.](?:jpe?g|png))/, `_${size}x$1`)
  }

  validateEmail (email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }

  initProductHtml (handle, variant) {
    fetch(`/products/${handle}?view=endpoint`)
      .then(response => response.json())
      .then(product => {
        const oosVariant = product.variants.find(e => +e.id === +variant)
        const variantSelectionHtml = `<input type="hidden" name="variant" value="${oosVariant.id}"> <p class="bis-product__variant">${oosVariant.title}</p>`

        const productHtml = `
          <div class="bis-product">
            <div class="bis-product__image">
              <img src="${this.getImageWithSize(product.featured_image, 150)}" />
            </div>
            <div class="bis-product__info">
              ${product.type ? `<p class="bis-product__subtitle">${product.type}</p>` : ''}
              <p class="bis-product__title">${product.title}</p>
              ${variantSelectionHtml}
            </div>
          </div>
        `

        document.querySelector('[bis-product-holder]').innerHTML = productHtml
        document.querySelector('[bis-product-holder]').classList.remove('hidden')
      })
  }

  handleSubmit (event) {
    event.preventDefault();
    const method = event.target.getAttribute('method')
    const url = event.target.getAttribute('action')
    const formEntries = new FormData(event.target).entries();
    const formData = Object.assign(...Array.from(formEntries, ([x, y]) => ({ [x]: y })));

    if (!this.validateEmail(formData.email)) {
      this.emailInput.classList.add('register__input--error')
      this.errorMessage.classList.remove('hidden')
      return false;
    } else {
      this.emailInput.classList.remove('register__input--error')
      this.errorMessage.classList.add('hidden')
    }

    const optionsFetch = {
      method: "POST",
      headers: {
        accept: "application/json",
        revision: "2024-06-15",
        "content-type": "application/json"
      },
      body: JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: formData.email
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${formData.variant}`
              }
            }
          }
        }
      })
    };

    fetch(url, optionsFetch).then(response => {
      return response
    }).then(resp => {
      if (resp.status === 202) {
        document.querySelector('.klaviyo-bis__success').outerHTML = document.querySelector('.klaviyo-bis__success').outerHTML.replace(/template/g, 'div')
        document.querySelector('.klaviyo-bis-form').classList.add('hidden')
      }
    }).catch((error) => {
      console.error('Error:', error);
    })
  }
}

customElements.define('klaviyo-modal', KlaviyoModal);
